<script>
	export let value;
</script>

<label for="page-type">Select page type</label>
<select name="" id="page-type" bind:value required>
	<option value="homepage">Homepage</option>
	<option value="productDetails">Product details page</option>
	<option value="cart">Cart page</option>
	<option value="landing">Landing page</option>
	<option value="category">Category page</option>
	<option value="404">404 page</option>
	<option value="other">Other</option>
</select>
